// Insights Helpers
// --------------------------------------------------------
const state = {
  topics: [], // Temporal list of topicsId used to create/edit Insights
  commentId: null // Temporal reference used to edit comments
}

const getters = {
  tempTopics: state => state.topics,
  tempComment: state => state.commentId,
  path(state, getters, rootState, rootGetters) {
    const landscapeId = rootGetters.currentLandscape._id
    return `landscapes/${landscapeId}/insights/`
  },
  commentPath(state, getters, rootState, rootGetters) {
    const insight = rootGetters['insights/current']
    if (!insight) return '' // VueTools fix !?
    return `${getters.path}${insight._id}/comments`
  },
  hasAdminRights: (state, getters, rootState, rootGetters) => insight => {
    const currentState = getters.currentState(insight)
    return (
      rootGetters.hasAdminRights ||
      insight.author === rootGetters.userId ||
      currentState.user === rootGetters.userId
    )
  },
  currentState: () => insight => {
    return insight.steps ? insight.steps[insight.steps.length - 1] : null
  }
}

const mutations = {
  addTempTopic(state, topicId) {
    state.topics.push(topicId)
  },
  removeTempTopic(state, topicId) {
    const index = state.topics.findIndex(id => id === topicId)
    state.topics.splice(index, 1)
  },
  addTempTopics(state, topics) {
    state.topics = []
    topics.map(topic => state.topics.push(topic._id))
  },
  removeTempTopics(state) {
    state.topics = []
  },
  setTempComment(state, commentId) {
    // state.comment = state.current.comments.find(comment => comment._id === commentId)
    state.commentId = commentId
  },
  removeTempComment(state) {
    state.commentId = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
